<div class="custom-avatar" [ngStyle]="avatarStyle" [ngClass]="{ 'rounded': rounded }">
  <ng-container *ngIf="contact | contactAvatar as initials; else unknown">
    {{ initials }}
  </ng-container>

  <ng-template #unknown>
    <i class="fa-solid fa-user"></i>
  </ng-template>
</div>
